import React from "react";
import { useBaseFulfillmentCtx } from "./BaseFulfillmentProvider";
import styled from "styled-components";
import { Radio } from "antd";
import {
    MANGOTEEPRINTS_CATALOG_TYPE,
    PRINTWAY_MADE_IN_LOCATION,
    SNAPECOM_SHIPPING_FROM,
} from "../../tasks/artist/constants";
import { reducerFn } from "../../../helper";

const OPTIONS = MANGOTEEPRINTS_CATALOG_TYPE.map((i) => ({
    value: i,
    label: i,
}));

const PRINTWAY_MADE_IN_LOCATIONS = PRINTWAY_MADE_IN_LOCATION.map((i) => ({
    value: i,
    label: i,
}));

const SNAPECOM_SHIPPING_FROM_ARRAY = SNAPECOM_SHIPPING_FROM.map((i) => ({
    value: i,
    label: i,
}));

const GEARMENT_VERSIONS = [
    { value: "", label: "Default" },
    { value: "v3", label: "Version 3" },
];

export default function WrapBaseFulfillmentID({
    children,
    printer: printerProp,
    madeInLocation,
    isEdit,
    onChangeMadeInLocation,
}) {
    const { isMangoTeePrints, isPrintway, isGearment, isSnapEcom } =
        useBaseFulfillmentCtx();

    const [state, setState] = React.useReducer(reducerFn, {
        printer: isGearment
            ? "v3"
            : printerProp || MANGOTEEPRINTS_CATALOG_TYPE[0],
        madeInLocation: "",
    });

    const handleChange = React.useCallback(
        (evt) => {
            const { value, name } = evt?.target;
            setState({ [name]: value });

            if (
                (isPrintway || isSnapEcom) &&
                name === "madeInLocation" &&
                onChangeMadeInLocation
            ) {
                onChangeMadeInLocation(value);
            }
        },
        [isPrintway, isSnapEcom, onChangeMadeInLocation],
    );

    React.useEffect(() => {
        if (!printerProp) return;
        setState({ printer: printerProp });
    }, [printerProp]);

    React.useEffect(() => {
        if (!madeInLocation) return;
        setState({ madeInLocation });
    }, [madeInLocation]);

    React.useEffect(() => {
        setState({
            printer: isGearment
                ? "v3"
                : isMangoTeePrints
                ? printerProp || MANGOTEEPRINTS_CATALOG_TYPE[0]
                : "",
        });
    }, [isMangoTeePrints, isGearment]);

    return isMangoTeePrints || isPrintway || isGearment || isSnapEcom ? (
        <Wrap>
            {isMangoTeePrints ? (
                <div className="printer-wrap">
                    <label htmlFor="printer">Printers</label>
                    <Radio.Group
                        disabled={!!isEdit}
                        id="printer"
                        name="printer"
                        value={state.printer}
                        defaultValue={state.printer}
                        onChange={handleChange}
                        options={OPTIONS}
                    />
                </div>
            ) : null}

            {isGearment && !isEdit ? (
                <div className="printer-wrap">
                    <label htmlFor="printer">API Version</label>
                    <Radio.Group
                        disabled={!!isEdit}
                        id="printer"
                        name="printer"
                        value={state.printer}
                        defaultValue={state.printer}
                        onChange={handleChange}
                        options={GEARMENT_VERSIONS}
                    />
                </div>
            ) : null}

            {children(state)}

            {isPrintway ? (
                <div className="made-in-location-wrap">
                    <label htmlFor="madeInLocation">Made in Location</label>
                    <Radio.Group
                        id="madeInLocation"
                        name="madeInLocation"
                        value={state.madeInLocation}
                        defaultValue={state.madeInLocation}
                        onChange={handleChange}
                        options={PRINTWAY_MADE_IN_LOCATIONS}
                    />
                </div>
            ) : null}
            {isSnapEcom ? (
                <div className="made-in-location-wrap">
                    <label htmlFor="madeInLocation">Shipping From</label>
                    <Radio.Group
                        id="madeInLocation"
                        name="madeInLocation"
                        value={state.madeInLocation}
                        defaultValue={state.madeInLocation}
                        onChange={handleChange}
                        options={SNAPECOM_SHIPPING_FROM_ARRAY}
                    />
                </div>
            ) : null}
        </Wrap>
    ) : (
        children()
    );
}

const Wrap = styled.div`
    .printer-wrap,
    .made-in-location-wrap {
        display: flex;
        flex-direction: column;
        margin-top: 1rem;
    }
`;
